import { backendClient } from "@/lib/backend-api";
import { safe } from "@orpc/client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export const useBillingInfo = () => {
  return useQuery({
    queryKey: ["billingInfo"],
    queryFn: () => {
      return safe(backendClient.billing.getBillingInfo());
    },
  });
};

export const useBillingPlans = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["billingPlans"],
    enabled: options?.enabled ?? true,
    queryFn: () => {
      return safe(backendClient.billing.getPlans());
    },
  });
};

export const useBillingSubscription = () => {
  return useQuery({
    queryKey: ["billingSubscription"],
    queryFn: () => {
      return safe(backendClient.billing.getActiveSubscription());
    },
  });
};

export const useSubscribeToBillingPlan = () => {
  return useMutation({
    mutationFn: (input: { planId: number }) => {
      return safe(backendClient.billing.subscribeToPlan(input));
    },
    onSuccess: (result) => {
      if (result.error) {
        console.error(`Failed to subscribe to plan`, result.error);
        toast.error("Failed to subscribe to plan");
      }
    },
    onError: (error) => {
      console.error("Failed to subscribe to plan:", error);
      toast.error("Failed to subscribe to plan");
    },
  });
};

export const useCancelBillingSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { subscriptionId: number }) => {
      return safe(backendClient.billing.cancelSubscription(input));
    },
    onSuccess: (result) => {
      if (result.error) {
        console.error(`Failed to cancel subscription`, result.error);
        toast.error("Failed to cancel subscription");
      } else {
        toast.success("Subscription cancelled");
        queryClient.invalidateQueries({
          queryKey: ["billingSubscription"],
        });
      }
    },
    onError: (error) => {
      console.error("Failed to cancel subscription:", error);
      toast.error("Failed to cancel subscription");
    },
  });
};
